"use client";

import { Children } from "@/types/types";
import { usePathname } from "next/navigation";
import { createContext, useContext, useEffect, useState } from "react";
import { MenuContext } from "./menuContext";
import { BookMenuContext } from "./bookMenuContext";

interface BlackOpacityContextProps {
  isBlackOpacityOpen: boolean | undefined;
  toggleBlackOpacity: () => void;
  openBlackOpacity: () => void;
  closeBlackOpacity: () => void;
}

const BlackOpacityContextInit = {
  isBlackOpacityOpen: false,
  toggleBlackOpacity: () => {},
  openBlackOpacity: () => {},
  closeBlackOpacity: () => {},
};

interface BlackOpacityProviderProps {
  children: Children;
}

export const BlackOpacityContext = createContext<BlackOpacityContextProps>(
  BlackOpacityContextInit
);

function BlackOpacityProvider({ children }: BlackOpacityProviderProps) {
  const pathname = usePathname();

  const { isMenuOpen } = useContext(MenuContext);
  const { isBookMenuOpen } = useContext(BookMenuContext);

  const [isBlackOpacityOpen, setBlackOpacityOpen] = useState<
    boolean | undefined
  >(undefined);

  const openBlackOpacity = () => {
    setBlackOpacityOpen(true);
  };

  const closeBlackOpacity = () => {
    setBlackOpacityOpen(false);
  };

  useEffect(() => {
    closeBlackOpacity();
  }, [pathname]);

  useEffect(() => {
    if (isMenuOpen) {
      openBlackOpacity();
    } else {
      closeBlackOpacity();
    }
  }, [isMenuOpen]);

  useEffect(() => {
    if (isBookMenuOpen) {
      openBlackOpacity();
    } else {
      closeBlackOpacity();
    }
  }, [isBookMenuOpen]);

  return (
    <BlackOpacityContext.Provider
      value={{
        isBlackOpacityOpen,
        toggleBlackOpacity: () => setBlackOpacityOpen(!isBlackOpacityOpen),
        openBlackOpacity,
        closeBlackOpacity,
      }}
    >
      {children}
    </BlackOpacityContext.Provider>
  );
}

export default BlackOpacityProvider;
